// import styles from './NoPage.module.css';

function NoPage() {
    return <p>No page found</p>;
}

export default NoPage;
